import { render, staticRenderFns } from "./LenderTermsAndConditionsActivity.vue?vue&type=template&id=86bf9476&"
import script from "./LenderTermsAndConditionsActivity.vue?vue&type=script&lang=js&"
export * from "./LenderTermsAndConditionsActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports